import { initializeApp, getApps, getApp } from 'firebase/app';
import { getAuth, initializeAuth, inMemoryPersistence } from 'firebase/auth';
// firestore/lite: the app's only Firestore use is a one-shot getDoc on the
// users collection — the full SDK (realtime/offline, ~1.9MB source) is not
// needed and dominates the main chunk if imported.
import { getFirestore, doc, getDoc } from 'firebase/firestore/lite';
import { getConfig } from '../config/config';

export const firebaseConfig = {
  apiKey: getConfig('REACT_APP_FIREBASE_PUB_KEY'),
  authDomain: getConfig('REACT_APP_FIREBASE_AUTH_DOMAIN'),
  databaseURL: getConfig('REACT_APP_FIREBASE_DATABASE_URL'),
  projectId: getConfig('REACT_APP_FIREBASE_PROJECT_ID'),
  storageBucket: getConfig('REACT_APP_FIREBASE_STORAGE_BUCKET'),
  messagingSenderId: getConfig('REACT_APP_FIREBASE_MESSAGING_SENDER_ID'),
  appId: getConfig('REACT_APP_FIREBASE_APP_ID'),
};

const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

const auth = getAuth(app);

// Secondary app for gift card step-up OTP. Signing in here never touches the
// default auth instance, so the email session stays signed in, and in-memory
// persistence keeps the phone session out of storage. Created lazily so the
// app isn't initialized for users who never redeem.
const STEP_UP_APP_NAME = 'stepup';
const STEP_UP_RECAPTCHA_CONTAINER_ID = 'recaptcha-container-stepup';
let stepUpAuth = null;

const getStepUpAuth = () => {
  if (!stepUpAuth) {
    const stepUpApp = getApps().find(({ name }) => name === STEP_UP_APP_NAME)
      || initializeApp(firebaseConfig, STEP_UP_APP_NAME);
    stepUpAuth = initializeAuth(stepUpApp, { persistence: inMemoryPersistence });
  }

  return stepUpAuth;
};

const getCurrentIdToken = async () => (await auth.currentUser?.getIdToken()) || '';

const fetchUserInfo = async (userId) => {
  try {
    const snapshot = await getDoc(doc(getFirestore(app), 'users', userId));

    return snapshot.exists() ? snapshot.data() : {};
  } catch (error) {
    return error;
  }
};

export {
  auth,
  getStepUpAuth,
  STEP_UP_RECAPTCHA_CONTAINER_ID,
  getCurrentIdToken,
  fetchUserInfo,
};
